export const STYLES = [
  // ─── Primary flagships ───
  { id: "afro-scifi", name: "Afro Sci-Fi", desc: "Dark cosmic · glowing hieroglyphs · gold/cyan", accent: "#F2C94C", group: "Primary",
    thumb: "https://images.unsplash.com/photo-1608889825205-eebdb9fc5806?w=400&auto=format&q=70" },
  { id: "animation", name: "Animation", desc: "Smooth stylized 3D · vibrant color", accent: "#00E5FF", group: "Primary",
    thumb: "https://images.unsplash.com/photo-1633613286848-e6f43bbafb8d?w=400&auto=format&q=70" },
  // Afro Sci-Fi & Animation family
  { id: "afro-egyptian", name: "Egyptian Futura", desc: "Ancient glyphs · cosmic gold", accent: "#F2C94C", group: "Afro Sci-Fi & Animation",
    thumb: "https://images.unsplash.com/photo-1527219002998-9e1b7ebedcb5?w=400&auto=format&q=70" },
  { id: "wakanda-tech", name: "Wakanda Tech", desc: "Vibranium · obsidian armor", accent: "#00E5FF", group: "Afro Sci-Fi & Animation",
    thumb: "https://images.unsplash.com/photo-1760981764541-dfbc3290f9f3?w=400&auto=format&q=70" },
  { id: "cosmic-royalty", name: "Cosmic Royalty", desc: "Starscape · celestial regalia", accent: "#E27D60", group: "Afro Sci-Fi & Animation",
    thumb: "https://images.unsplash.com/photo-1628857544646-8855ba92827e?w=400&auto=format&q=70" },
  { id: "solar-desert", name: "Solar Desert", desc: "Terracotta · ochre dynasty", accent: "#F2994A", group: "Afro Sci-Fi & Animation",
    thumb: "https://images.unsplash.com/photo-1772289935102-bf978ceda1b2?w=400&auto=format&q=70" },
  { id: "african-anime-2d", name: "2D African Anime", desc: "Ink cel · bold flat color", accent: "#EB5757", group: "Afro Sci-Fi & Animation",
    thumb: "https://images.unsplash.com/photo-1578632767115-351597cf2477?w=400&auto=format&q=70" },
  { id: "afro-3d-animation", name: "3D Animation", desc: "Pixar-grade · stylized rig", accent: "#00E5FF", group: "Afro Sci-Fi & Animation",
    thumb: "https://images.unsplash.com/photo-1633613286848-e6f43bbafb8d?w=400&auto=format&q=70" },
  { id: "scifi-action", name: "Sci-Fi Action", desc: "Explosive · movie-poster punch", accent: "#EB5757", group: "Afro Sci-Fi & Animation",
    thumb: "https://images.unsplash.com/photo-1608889825205-eebdb9fc5806?w=400&auto=format&q=70" },
  { id: "afro-steampunk", name: "Afro Steampunk", desc: "Brass · gears · sepia dynasty", accent: "#B8860B", group: "Afro Sci-Fi & Animation",
    thumb: "https://images.unsplash.com/photo-1517420704952-d9f39e95b43e?w=400&auto=format&q=70" },
  { id: "nuwaupia", name: "Nuwaupia", desc: "Nubian pyramid cities · cobalt starcraft", accent: "#3B5FE2", group: "Afro Sci-Fi & Animation",
    thumb: "https://images.unsplash.com/photo-1568322445389-f64ac2515020?w=400&auto=format&q=70" },
  // Universal
  { id: "cinematic-3d", name: "Cinematic 3D", desc: "Volumetric · film-grade", accent: "#F2C94C", group: "Universal",
    thumb: "https://images.unsplash.com/photo-1633355444132-695d5876cd00?w=400&auto=format&q=70" },
  { id: "photoreal", name: "Photorealism", desc: "85mm · DSLR truth", accent: "#00E5FF", group: "Universal",
    thumb: "https://images.unsplash.com/photo-1531123897727-8f129e1688ce?w=400&auto=format&q=70" },
  { id: "illustration-2d", name: "2D Illustration", desc: "Ink lines · flat color", accent: "#E27D60", group: "Universal",
    thumb: "https://images.unsplash.com/photo-1618004652321-13a63e576b80?w=400&auto=format&q=70" },
  { id: "surprise", name: "Surprise Me", desc: "Wild fusion mode", accent: "#A09B8C", group: "Universal",
    thumb: "https://images.unsplash.com/photo-1568782517100-09bf22d88c2d?w=400&auto=format&q=70" },
];

export const STYLE_GROUPS = ["Primary", "Afro Sci-Fi & Animation", "Universal"];

export const STYLE_LABELS = STYLES.reduce((acc, s) => { acc[s.id] = s.name; return acc; }, {});
export const styleLabel = (id) => STYLE_LABELS[id] || id;
export const styleThumb = (id) => STYLES.find((s) => s.id === id)?.thumb;

export const PROMPT_LIBRARY = {
  "afro-scifi": [
    "A regal Nubian starlord in obsidian armor, glowing hieroglyphs orbiting the shoulders, deep cosmic backdrop",
    "Twin oracles in cyan-lit robes, gold ankh floating overhead, nebula reflecting on onyx skin",
    "Warrior priestess wielding a vibranium staff, hieroglyph runes streaming into the void",
    "Afrofuturist starship cockpit — pilot with gold-thread braids, control glyphs pulsing cyan",
  ],
  "animation": [
    "Stylized 3D hero mid-sprint, vibrant coral cape trailing, warm rim light",
    "Colorful animated marketplace scene, jubilant characters, big Pixar-grade shapes",
    "Whimsical 3D child inventor with a glowing gadget, playful expression, bright teal sky",
    "Cel-shaded superhero landing pose, dust plume, saturated sunset gradient",
  ],
  "afro-egyptian": [
    "A pharaoh queen crowned with holographic hieroglyphs, gold ankh scepter glowing",
    "Anubis-inspired guardian in obsidian armor, cosmic constellations across the chest",
    "Ancient Nubian temple humming with vibranium light rings",
    "Ra's chariot reimagined as a starship, gilded sun-disc engine",
  ],
  "wakanda-tech": [
    "Warrior princess in vibranium-woven kente, teal light seams pulsing",
    "Skyline of a hidden Wakandan citadel at dusk, floating vibranium panels",
    "Dora Milaje sentinel projecting a holographic tribal shield",
    "Sleek maglev market street, obsidian steel and neon glyphs",
  ],
  "cosmic-royalty": [
    "Queen of a nebula dynasty, hair woven with galaxies, crown of quasars",
    "Twin king and queen suspended in orbit, robes trailing stardust",
    "Star-priestess reading celestial glyphs from a floating scroll",
    "Regal figure walking a bridge of comets between two moons",
  ],
  "solar-desert": [
    "Dune rider on a solar-panel steed, ochre robes catching sun-flare",
    "City carved into cliffside sandstone, terracotta domes lit at golden hour",
    "Nomad architect drawing sun-glyphs into a shimmering dune",
    "Desert oracle wrapped in copper thread, sun disc halo above",
  ],
  "african-anime-2d": [
    "Cel-shaded warrior queen mid-leap, kente cape flaring behind her, dramatic anime speed lines",
    "Two rival street racers on hover-bikes, Lagos skyline glowing, kinetic anime frames",
    "Ink-drawn spirit guardian summoning ancestral flames, big anime eyes, thick lineart",
    "Shonen-style young hero unlocking gold vibranium powers, energy aura, halftone shading",
  ],
  "afro-3d-animation": [
    "Stylized 3D character of a young Afro sci-fi inventor in a workshop, Pixar-grade lighting",
    "Chibi 3D warrior with oversized spear, expressive rig, soft global illumination",
    "3D animated grandmother spinning cosmic thread, warm sub-surface skin scattering",
    "Team of 3D animated heroes striking a hero pose, cinematic key light, film-grade",
  ],
  "scifi-action": [
    "Warrior mid-combat leaping over a fireball, gold shrapnel, cinematic explosion behind",
    "Two rival mecha pilots clashing on a neon rooftop, sparks and lens flare, action still",
    "Sprinting soldier in vibranium armor firing a plasma cannon, motion blur, dust trails",
    "Rooftop parkour chase — heroine leaping between hovercars, dynamic Dutch angle",
  ],
  "afro-steampunk": [
    "Brass-goggled inventor with kente-woven leather coat, steam pistons behind her",
    "Airship pilot flying over a Saharan skyline, copper cogs and gears whirring, sepia clouds",
    "Steampunk queen on a cog-throne, ornate brass crown fused with cowrie shells and hieroglyphs",
    "Blacksmith creating vibranium gears in a lantern-lit atelier, amber sparks flying",
  ],
  "nuwaupia": [
    "A Nubian priestess in black-and-gold ceremonial robes standing atop a sandstone pyramid, a saucer beaming cobalt light onto her ankh scepter, starfield behind",
    "Melanated star-warriors marching between lotus-topped obelisks under a hovering mothership, hieroglyphic sashes glowing gold",
    "Grand Nuwaubian temple complex at dusk — pyramid city lit by winged sun disk, sacred script floating mid-air, deep cobalt and burnt orange sky",
    "Close-up of an Eye of Horus etched into obsidian, cosmic starlight refracting through it, Nuwaubian glyphs orbiting in gold",
  ],
  "cinematic-3d": [
    "Volumetric portrait of a lone traveler, god-rays cutting through fog",
    "Underwater cathedral illuminated by bioluminescent creatures",
    "Cyberpunk alley in the rain, cinematic anamorphic bokeh",
    "Sculpted 3D character with sub-surface skin scattering, dramatic keylight",
  ],
  photoreal: [
    "Editorial portrait of a young Black woman in soft window light, natural skin texture, shallow depth of field, 85mm",
    "Street photograph of a Lagos market at golden hour, candid, film grain, National Geographic feel",
    "Studio still-life of gilded ceremonial objects on black velvet, ring-light rim, macro detail",
    "Documentary shot of a farmer at dawn, warm rim light, dust particles, cinematic realism",
    "Fashion editorial cover — model in vibranium-inspired armor, high-key studio strobe, 4x5 large-format sharpness",
    "Environmental portrait of a graffiti artist in a Brooklyn alley, sodium streetlamp, wet asphalt reflections",
  ],
  "illustration-2d": [
    "Storybook heroine standing under a giant baobab, flat vibrant colors",
    "Ink-lined comic panel of a masked hero mid-leap over rooftops",
    "Paper-cut style scene of a market bustling with vendors",
    "Editorial magazine cover with bold shapes and typography",
  ],
  surprise: [
    "Something no one has imagined before — surprise me with a bold fusion",
    "A concept that mixes two eras and two continents in one image",
    "Break the algorithm — unusual composition, unexpected palette",
    "Make it strange, make it beautiful, make it yours",
  ],
};

export const BIO_TONES = [
  { id: "mythic",    label: "Mythic",    hint: "Ancestral · ceremonial · dynastic",   accent: "#F2C94C" },
  { id: "cinematic", label: "Cinematic", hint: "Movie-trailer · dramatic · epic",     accent: "#00E5FF" },
  { id: "cyberpunk", label: "Cyberpunk", hint: "Neon · glitch · tech-noir attitude",  accent: "#E27D60" },
];
